import isEmpty from 'lodash/isEmpty';

export const maxDigits = length => (value, previousValue) => {
  if (isEmpty(value)) {
    return null;
  }
  return value.match(/^[0-9]+$/) && value.length <= length
    ? value
    : previousValue;
};

// Italian tax code
export const taxCode = () => (value, previousValue) => {
  const length = 16;

  if (isEmpty(value)) return null;

  const regex = new RegExp('^[a-zA-Z0-9]+$');
  return value.match(regex) && value.length <= length ? value : previousValue;
};

// Passport number
export const passportNumber = country => (value, previousValue) => {
  let length;
  let regex;

  if (isEmpty(value)) return null;

  if (country.toLowerCase() === 'ru') {
    // https://sayari.com/decoding-russian-passport-numbers/
    length = 10;
    regex = new RegExp('^[0-9]+$');
  } else {
    // no other implementation
    return previousValue;
  }

  return value.match(regex) && value.length <= length ? value : previousValue;
};
